import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { UserProfile, UserUpdate } from 'types/api'

export function usePatchProfile() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError
  const { t } = useTranslation('users') // Added translation hook

  async function updateProfile(args: UserUpdate) {
    const res = await apiClient.patch<UserProfile>(
      SNA_PREFIX + `users/me`,
      args
    )
    return res.data
  }

  return useMutation({
    mutationFn: updateProfile,
    onSuccess: () => {
      toast.success({ message: t('toast.profileUpdated') })
      queryClient.invalidateQueries({ queryKey: ['profile'] })
    },
    onError // Updated to use useOnError
  })
}
